import Dexie from 'dexie';

/**
 * Generic record stored in the local databases. Additional fields may
 * be present depending on the usage.
 */
export interface Document {
  id?: number;
  [key: string]: any;
}

/**
 * Database used to store login related information.
 */
class MyAppDatabase extends Dexie {
  documents: Dexie.Table<Document, number>;

  constructor() {
    super('LoginDatabase');
    this.version(1).stores({
      documents: '++id'
    });
    this.documents = this.table('documents');
  }
}

/**
 * Database dedicated to application logs.
 */
class LogsDatabase extends Dexie {
  documents: Dexie.Table<Document, number>;

  constructor() {
    super('LogsDatabase');
    this.version(1).stores({
      documents: '++id'
    });
    this.documents = this.table('documents');
  }
}


/**
 * Database that keeps different payloads generated by the app.
 */
class PayloadsDatabase extends Dexie {
  documents: Dexie.Table<Document, number>;

  constructor() {
    super('PayloadsDatabase');
    this.version(1).stores({
      documents: '++id'
    });
    this.documents = this.table('documents');
  }
}

/**
 * Database to store front-end configuration values.
 */
class ConfigurationsDataBase extends Dexie {
  documents: Dexie.Table<Document, number>;

  constructor() {
    super('ConfigurationsDataBase');
    this.version(1).stores({
      documents: '++id'
    });
    this.documents = this.table('documents');
  }
}

/** Instance to interact with the logs database */
export const logDb = new LogsDatabase();
/** Instance to interact with the payloads database */
export const payloadsDB = new PayloadsDatabase();
/** Instance to interact with the login database */
export const db = new MyAppDatabase();
/** Instance to interact with the configurations database */
export const configurationsDB = new ConfigurationsDataBase();